import React, { FC, memo } from "react";

interface IProps {
  size?: number;
}

const CalculateNeedIcon: FC<IProps> = ({ size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11.5 11.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 10.75L6.04411 6.04411M4.27941 1.92647V0.75M4.27941 7.80882V6.63235M1.92647 4.27941H0.75M7.80882 4.27941H6.63235M2.80883 2.80883L1.561 1.561M2.80884 5.75002L1.56101 6.99785M6.99785 1.56098L5.75001 2.80881"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(CalculateNeedIcon);
